import React from "react";
import { Route } from "react-router-dom";
import ProviderSignIn from "../components/provider_signin";
import ProviderSignUp from "../components/provider_signup";
import ProviderForgotPassword from "../components/provider_forgot_password";
import ProviderResetPassword from "../components/provider_reset_password";

const SignInRoutes = () => {
  return (
    <>
      <Route path="signin" element={<ProviderSignIn />} /> 
      <Route path="signup" element={<ProviderSignUp />} /> 
      <Route path="forgot-password" element={<ProviderForgotPassword />} /> 
      <Route path="reset-password/:token" element={<ProviderResetPassword />} /> 
    </>
  );
};

export default SignInRoutes;
